import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Admin from './Admin';
import QuranAdmin from './QuranAdmin';
import AmalAdmin from './AmalAdmin';
import Receipt from './Receipt';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/quran-admin" element={<QuranAdmin />} />
        <Route path="/amal-admin" element={<AmalAdmin />} />
        <Route path="/receipt" element={<Receipt />} />
      </Routes>
    </HashRouter>
  </React.StrictMode>
);
